export type ReviewTemplateEditorMode = 'edit' | 'clone';

export interface ReviewTemplateEditorContext {
  checklistId: string;
  sourceTemplateId: string;
  mode: ReviewTemplateEditorMode;
  returnTo: string;
  cloneName?: string;
}

export function reviewTemplateEditorHref(context: ReviewTemplateEditorContext): string {
  const query = new URLSearchParams({
    reviewChecklistId: context.checklistId,
    sourceTemplateId: context.sourceTemplateId,
    mode: context.mode,
    returnTo: context.returnTo,
  });
  if (context.cloneName !== undefined) query.set('cloneName', context.cloneName);
  return `/sales/templates?${query.toString()}`;
}

export function reviewTemplateEditorContextFrom(
  search: string,
): ReviewTemplateEditorContext | null {
  const query = new URLSearchParams(search);
  const checklistId = query.get('reviewChecklistId')?.trim() ?? '';
  const sourceTemplateId = query.get('sourceTemplateId')?.trim() ?? '';
  const mode = query.get('mode');
  const returnTo = query.get('returnTo')?.trim() ?? '';
  if (
    checklistId === '' ||
    sourceTemplateId === '' ||
    (mode !== 'edit' && mode !== 'clone') ||
    !returnTo.startsWith('/batches/')
  ) {
    return null;
  }
  const cloneName = query.get('cloneName')?.trim();
  return {
    checklistId,
    sourceTemplateId,
    mode,
    returnTo,
    ...(cloneName === undefined || cloneName === '' ? {} : { cloneName }),
  };
}

export function reviewReturnHref(returnTo: string, templateId: string): string {
  const [pathname, rawQuery = ''] = returnTo.split('?', 2);
  const query = new URLSearchParams(rawQuery);
  query.set('listingTemplate', templateId);
  return `${pathname}?${query.toString()}`;
}
